import { pageAndHomeworkHelperText } from '../../helpers/mergeFieldHelperText'

export default [
  {
    name: 'Week',
    prop: 'week_id',
    type: 'autocomplete',
    references: 'admin/weeks',
    referenceProp: 'long_name',
    query: {
      filters: {
        without_homeworks: true
      }
    }
  },
  { name: 'Show in Future?', prop: 'is_shown_in_future', type: 'checkbox' },
  { name: 'Title', prop: 'title', type: 'text' },
  { name: 'Vimeo URL', prop: 'vimeo_url', type: 'text' },
  { name: 'Excerpt', prop: 'excerpt', type: 'textarea' },
  {
    name: 'Body',
    prop: 'body',
    type: 'wysiwyg',
    helperText: pageAndHomeworkHelperText
  }
]
